// Listing Group tier touch_action codes that Condor branches on. The full table
// lives in condor/docs/ENUM_REFERENCE.md (touch_action); Vulture's option list is in
// ui/app/src/Crow/Form/Field/Custom/Vulture/consts.js — keep the two in sync.
export const TOUCH_ACTION_WAYFINDING_MODAL = 8;   // row tap -> details page, MAP button -> modal
export const TOUCH_ACTION_DIRECT_WAYFINDING = 14; // DEV-12130: row tap AND MAP button -> modal

// Actions that render the MAP button on the listing row / header.
export const isWayfindingModalAction = (action) =>
	action === TOUCH_ACTION_WAYFINDING_MODAL || action === TOUCH_ACTION_DIRECT_WAYFINDING;
